import {Component, h, Host, Prop} from '@stencil/core';
import {SearchCompanyViewModel} from "@modules/onBoarding/presentation/viewModel/SearchCompanyViewModel";

@Component({
    tag: 'search-company-view',
    styleUrl: 'search-company-view.css',
    scoped: true,
})
export class SearchCompanyView {

    @Prop() viewModel: SearchCompanyViewModel;

    render() {
        return (
            <Host>
                <div class="container-fluid">
                    <div id="main" class="row">
                        <div id="leftBlock" class="col-12 col-md-5 p-0 bg-primary">
                            <div class="position-relative d-flex align-items-center">
                                <div id="leftBlock--text"
                                     class="position-absolute d-flex flex-column justify-content-center"
                                     data-testid="onboarding.search-company-view.leftblock"
                                >
                                    <svg class="mb-4" aria-hidden="true" width="100%" height="2rem">
                                        <use data-href={this.viewModel.taglineHref}></use>
                                    </svg>
                                    <h1 class="title_xl text-white mb-4 mt-3">
                                        {this.viewModel.createAnAccount}
                                    </h1>
                                    <span class="title_xs text-white">
                                        {this.viewModel.welcome}
                                    </span>
                                </div>
                                <img class="w-100" src={this.viewModel.leftImageSrc} alt="Great working day. Delivered."/>
                            </div>
                        </div>
                        <div id="rightBlock" class="col-12 col-md-7 bg-light" data-testid="onboarding.search-company-view.rightblock">
                            <div class="container">
                                <nav class="row my-4">
                                </nav>
                                <div class="row justify-content-center">
                                    <div class="card shadow p-4 p-md-5">

                                        <input id="serviceLoginApiKey" type="hidden" value={this.viewModel.serviceLoginApiKey}/>
                                        <input id="serviceLoginUrl" type="hidden" value={this.viewModel.serviceLoginUrl}/>

                                        <search-company-form
                                            viewModel={this.viewModel.searchCompanyForm}>
                                        </search-company-form>
                                    </div>
                                </div>
                                <div class="row d-flex justify-content-center mt-4" data-testid="onboarding.search-company-view.footer">
                                    <span>{this.viewModel.needHelp}</span>
                                    <a href={this.viewModel.contactUsLink} class="pl-1">{this.viewModel.contactUs}</a>
                                    <span class="pl-1">or</span>
                                    <a href={this.viewModel.visitFaqLink} class="pl-1">{this.viewModel.visitFaq}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
